import DateFilter from '@/components/date-filter';
import ManageConfirmation from '@/views/stock/confirm-retour-stock/manage-confirmation'
import $ from 'jquery'

export default {
    name: 'confirm-retour-stock',
    components: {
        DateFilter, ManageConfirmation
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            retour_filters: [
                { status: 0, libelle: 'En attente' },
                { status: 1, libelle: 'Confirmé' }
            ],
            filter_by_confirmation: { status: 0, libelle: 'En attente' },

            is_loading: true,
            is_empty: false,
            is_load_error: false,

            fields: [
                { key: 'choix_operation', label: '#' }, { key: 'article', label: 'Article' },
                { key: 'qte', label: 'Qté' }, 'date'
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,

            selected_articles: [],
            can_do_action: false,
            toggle_modal: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.selected_articles = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                status: 0
            }
            this.current_date_filter = data
            this.getListeArticleARetourner(data)

            this.filter_by_confirmation = { status: 0, libelle: 'En attente' }
        },

        filter_by_confirmation() {
            this.selected_articles = []

            if (this.filter_by_confirmation.status == 1) {
                this.fields = [
                    { key: 'article', label: 'Article' },
                    { key: 'qte', label: 'Qté' }, 'date'
                ]
            } else {
                this.fields = [
                    { key: 'choix_operation', label: '#' }, { key: 'article', label: 'Article' },
                    { key: 'qte', label: 'Qté' }, 'date'
                ]
            }

            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                status: this.filter_by_confirmation.status
            }
            this.current_date_filter = data
            this.getListeArticleARetourner(data)
        },

        selected_articles() {
            if (this.selected_articles.length > 0) {
                this.can_do_action = true
            } else {
                this.can_do_action = false
            }
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters["authInfo"];
        },

        activeRole() {
            return this.$store.getters["activeRole"];
        },

        liste_articles_attente_de_retour() {
            return this.$store.getters["liste_articles_attente_de_retour"];
        },

        rows() {
            return this.liste_articles_attente_de_retour.length;
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },

    methods: {
        getListeArticleARetourner(data) {
            this.is_load_error = false
            this.is_loading = true
            this.$store.dispatch("getListeArticleEnAttenteRetour", data).then(() => {
                if (this.liste_articles_attente_de_retour.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        refreshListe() {
            this.getListeArticleARetourner(this.current_date_filter)
        },

        filterByDate(date) {
            this.selected_articles = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                status: 0
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.filter_by_confirmation = { status: 0, libelle: 'En attente' }

            this.getListeArticleARetourner(data)
        },

        checkAll() {
            let is_checked = $('#check-all').is(":checked")

            if (is_checked) {
                this.selected_articles = []

                this.liste_articles_attente_de_retour.forEach((article) => {
                    this.selected_articles.push(article)
                });
                this.all_checked = true
                
            } else {
                this.selected_articles = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("check-all").checked = false;
        },

        handleConfirmation() {
            this.toggle_modal = (this.toggle_modal == 0)?1:0
        }
    }
}